import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import ModalCargando from '../utilsComponentes/ModalCargando';
import UtilsBufer from '../Tools/UtilsBufer';
const server = process.env.REACT_APP_SERVER;

function NuevaNoticia(props) {
    const { cerrarModalAdd, info } = props
    const [regional,setRegional] = useState('');
    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [fotos, setFotos] = useState([]);
    const [modalUrl, setModalUrl] = useState(false);
    const [url, setUrl] = useState('');
    const [descripcionUrl, setDescripcionUrl] = useState('');
    const [links, setLinks] = useState([]);
    const [paraVerlo, setParaVerlo] = useState('L');
    const [tipoNoti, setTipoNoti] = useState('G');
    const [idAdjunto, setIdAdjunto] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fotoPortada, setFotoPortada] = useState([]);
    const [editando, setEditando] = useState(false);
    const [editandoNoticia,setEditandoNoticia] = useState({});
    const limpiarInfo = () => {
        setTitulo('');
        setDescripcion('');
        setFotoPortada([]);
        setFotos([]);
        setLinks([]);
        setIdAdjunto([]);
        setTipoNoti('G')
    }
    const cargarFoto = (e, tipo) => {
        setLoading(true);
        var archiv = e.target.files[0];
        var extencion = archiv.name.substring(archiv.name.lastIndexOf('.') + 1);
        var nameArchivo = archiv.name.substring(0,archiv.name.lastIndexOf('.')).replace(/\./g,'').replace(/\s+/g, '');
        if (archiv.size / 1000000 < 3.5) {
            var info = JSON.parse(localStorage.getItem('__react_session__'));
            var formData = new FormData()
            formData.append('FILE1', new Blob([archiv], { contentType: 'application/octet-stream', contentTransferEncoding: 'binary' }), `${nameArchivo}.${extencion}` + "." + info.regional + "." + info.idSession);
            try {
                axios.post(`${server}/redSocial/cargarImagen`, formData, {
                    'Accept': 'application/json',
                    'content-type': 'multipart/form-data'
                }).then(res => {
                    setLoading(false);
                    if (tipo === 1) {
                        setIdAdjunto([...idAdjunto, { "ID_IMAGEN": res.data.ok.V_ID, "NOMBRE_IMG": archiv.name }]);
                        setFotos([...fotos, archiv]);
                    } else {
                        setIdAdjunto([{ "ID_IMAGEN": res.data.ok.V_ID, "NOMBRE_IMG": archiv.name }, ...idAdjunto]);
                        setFotos([archiv, ...fotos]);
                        setFotoPortada([...fotoPortada, archiv]);
                    }
                }).catch(error => {
                    MsgUtils.msgError(error.message);
                    console.log(error.message);
                    setLoading(false);
                })
            } catch (error) {
                MsgUtils.msgError(error.message);
                console.error('Error al subir el archivo !!');
            }
        } else {
            setLoading(false);
            MsgUtils.msgError("Coloque Imagen < 3.5 Megas")
        }
    }
    const eliminarFoto = (dato, tipo) => {
        try {
            if(editando){
                fetch(`${server}/redSocial/removeFoto`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        regional: regional,
                        info:dato
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data)
                        if (data.ok) {
                            setFotos(fotos.filter(item => item.NOMBRE_IMG !== dato.NOMBRE_IMG));
                            setIdAdjunto(idAdjunto.filter(item => item.NOMBRE_IMG !== dato.NOMBRE_IMG));
                            if (tipo === 0) {
                                setFotoPortada([]);
                            } 
                            MsgUtils.msgCorrecto("foto eliminada")
                        } else {
                            MsgUtils.msgError(data.error);
                        }
                    })
                    .catch(err => MsgUtils.msgError(err));
            }else{
                setFotos(fotos.filter(item => item.name !== dato.name));
                setIdAdjunto(idAdjunto.filter(item => item.NOMBRE_IMG !== dato.name));
                if (tipo === 0) {
                    setFotoPortada([]);
                }   
            }
        } catch (error) {
            MsgUtils.msgError(error.message);        
        }
    }
    const agregarLink = () => {
        console.log(url, descripcionUrl)
        if (url !== '' && descripcionUrl !== '') {
            setLinks([...links, { "URL": url, "DESCRIPCION": descripcionUrl, "TIPO": paraVerlo }]);
            setUrl('');
            setDescripcionUrl('');
            setParaVerlo('L');
            setModalUrl(false);
        } else {
            MsgUtils.msgError("No se aceptan campos vacios")
        }
    }
    const guardarNoticia = () => {
        console.log(editandoNoticia)
        var idNoticia = editando?editandoNoticia.ID_NOTICIA:0;
        if (titulo !== '') {
            if (fotos.length >= 1) {
                var info = JSON.parse(localStorage.getItem('__react_session__'));
                fetch(`${server}/redSocial/newNoticia`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        regional: info.regional, titulo, descripcion,
                        tipo: tipoNoti, fotos: idAdjunto, links, idEmpleado: info.idSession, idNoticia:idNoticia
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.ok) {
                            MsgUtils.msgCorrecto("GUARDADO");
                            limpiarInfo();
                            cerrarModalAdd();
                        } else {
                            MsgUtils.msgError(data.error);
                        }
                    })
                    .catch(err => MsgUtils.msgError(err));
            } else {
                MsgUtils.msgError("Por lo menos tiene que haber una foto");
            }
        } else {
            MsgUtils.msgError("El titulo no puede ser vacio");
        }
    }
    function eliminarUrl(valor) {
        console.log(valor);
        if(!editando){
            setLinks(links.filter((item) => item.URL !== valor.URL));
        }else{
            fetch(`${server}/redSocial/removeUrls`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: regional,
                    info:valor
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if (data.ok) {
                        setLinks(links.filter((item) => item.URL !== valor.URL));
                        MsgUtils.msgCorrecto("foto eliminada")
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        }
    }
    useEffect(() => {
        var session = JSON.parse(localStorage.getItem('__react_session__'));
        if(regional===''){
            setRegional(session.regional);
        }
        if (info !== undefined) {
            setEditandoNoticia(info)
            setEditando(true);
            setTitulo(info.TITULO);
            setDescripcion(UtilsBufer.getText(info.DESCRIPCION));
            setTipoNoti(info.TIPO_NOTICIA);
            fetch(`${server}/redSocial/getMensajeLinks`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: ''+session.regional,
                    idNoticia: info.ID_NOTICIA,
                    tipo: 'E'
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    //setLoading(false);
                    if (data.ok) {
                        setLinks(data.ok.links);
                        var fotosN = data.ok.imagenes;
                        if (fotosN.length === 1) {
                            setFotoPortada(fotosN)
                        } else {
                            var aux = fotosN.filter((item) => item.NOMBRE_IMG === info.NOMBRE_IMG)
                            setFotoPortada(aux)
                            setFotos([...aux, ...fotosN.filter((item) => item.NOMBRE_IMG !== info.NOMBRE_IMG)]);
                            setIdAdjunto([...aux,...fotosN.filter((item) => item.NOMBRE_IMG !== info.NOMBRE_IMG)]);
                        }
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(err => console.log(err));
        }
    }, [])
    return (
        <div className=''>
            <div className="mx-auto card bg-dark bg-gradient ">
                <div className='card-header'>
                    <div className="input-group my-auto" style={{ height: "25px" }}>
                        <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>Titulo</span>
                        <input type="text" className="form-control"
                            maxLength="90"
                            placeholder='Titulo de Noticia' style={{ height: "25px" }}
                            value={titulo} onChange={(e) => setTitulo(e.target.value)} />
                    </div>
                </div>
                <div className="card-body">
                    <div className="form-floating">
                        <textarea className="form-control"
                            placeholder="Descripcion Noticia"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            style={{ height: "140px" }}>
                        </textarea>
                        <label >Descripción</label>
                    </div>
                    <div className="input-group my-2" style={{ height: "25px" }}>
                        <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>Tipo de Noticia</span>
                        <select className=" form-select form-select-sm text-center m-0 p-0"
                            value={tipoNoti}
                            style={{ height: "25px" }}
                            onChange={(e) => setTipoNoti(e.target.value)}>
                            <option value='G'>Global</option>
                            <option value='D'>Destacado</option>
                        </select>
                    </div>
                    <div className='container-fluid py-2'>
                        <div className='row row-cols-1 row-cols-sm-2 g-1'>
                            <div className='col col-sm-11'>
                                <div className='container px-4 bg-secondary bg-gradient'>
                                    <span className='text text-light'>Foto de Portada</span>
                                    <ul className="list-group bg-secondary">
                                        {fotoPortada.map((item, i) => {
                                            return (
                                                <li className="list-group-item position-relative bg-dark bg-gradient text-light" key={i}>
                                                    {editando ? (item.NOMBRE_IMG!==undefined ? item.NOMBRE_IMG:item.name) : item.name}
                                                    <button className='btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'
                                                        id={item.name}
                                                        onClick={() => eliminarFoto(item, 0)}>
                                                        X
                                                    </button>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className='col col-sm-1'>
                                <label className='btn fs-1 text-success'>
                                    <i className="fa-solid fa-file-circle-plus"></i>
                                    <input type="file" accept='image/*' onChange={(e) => cargarFoto(e, 0)} />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='container-fluid py-2'>
                        <div className='row row-cols-1 row-cols-sm-2 g-1'>
                            <div className='col col-sm-11'>
                                <div className='container px-4 bg-secondary bg-gradient'>
                                    <span className='text text-light'>Fotos Para Detalles</span>
                                    <ul className="list-group bg-secondary">
                                        {fotos.map((item, i) => {
                                            if (fotoPortada.length === 0) {
                                                return (
                                                    <li className="list-group-item position-relative bg-dark bg-gradient text-light" key={i}>
                                                        {editando ? (item.NOMBRE_IMG!==undefined ? item.NOMBRE_IMG:item.name) : item.name}
                                                        <button className='btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'
                                                            id={item.name}
                                                            onClick={() => eliminarFoto(item, 1)}>
                                                            X
                                                        </button>
                                                    </li>
                                                )
                                            } else {
                                                if (i !== 0) {
                                                    return (
                                                        <li className="list-group-item position-relative bg-dark bg-gradient text-light" key={i}>
                                                            {editando ? (item.NOMBRE_IMG!==undefined ? item.NOMBRE_IMG:item.name) : item.name}
                                                            <button className='btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'
                                                                id={item.name}
                                                                onClick={() => eliminarFoto(item, 1)}>
                                                                X
                                                            </button>
                                                        </li>
                                                    )
                                                }
                                            }
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className='col col-sm-1'>
                                <label className='btn fs-1 text-success'>
                                    <i className="fa-solid fa-file-circle-plus"></i>
                                    <input type="file" accept='image/*' onChange={(e) => cargarFoto(e, 1)} />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='table-responsive container-fluid'>
                    <table className="table table-dark">
                        <thead >
                            <tr>
                                <th scope="col">
                                    <div className='container-fluid'>
                                        <span>Url</span>
                                        <button className='btn btn-sm m-0 p-0 text-light' onClick={() => setModalUrl(true)}>
                                            <i className="fa-solid fa-circle-plus fa-xl fa-bounce"></i></button>
                                    </div>
                                </th>
                                <th scope="col">Descripción</th>
                                <th scope="col">Ver</th>
                                <th scope="col">Eliminar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {links.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <th scope="row">{item.URL.substring(0, 10)}...</th>
                                        <td>{item.DESCRIPCION}</td>
                                        <td>{item.TIPO}</td>
                                        <td><button className='btn btn-sm text-danger'
                                            onClick={() => eliminarUrl(item)}>
                                            <i className="fa-solid fa-trash fa-xl"></i></button></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <div className='card-footer text-end'>
                    <button className='btn btn-success btn-sm' onClick={guardarNoticia}>
                        <i className="fa-solid fa-paper-plane"></i> Guardar
                    </button>
                </div>
            </div>
            <ModalCargando show={loading} />
            <Modal show={modalUrl} onHide={() => setModalUrl(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName='bg-dark bg-gradient text-light'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>Agregar Url de Youtube</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='card bg-dark bg-gradient'>
                        <div className='card-header'>
                            <div className="input-group my-auto" style={{ height: "25px" }}>
                                <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>URL</span>
                                <input type="text" className="form-control"
                                    placeholder='URL YOUTUBE' style={{ height: "25px" }}
                                    value={url} onChange={(e) => setUrl(e.target.value)} />
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="form-floating">
                                <textarea className="form-control"
                                    maxLength="80"
                                    placeholder="Descripcion Noticia"
                                    value={descripcionUrl}
                                    onChange={(e) => setDescripcionUrl(e.target.value)}
                                    style={{ height: "100px" }}>
                                </textarea>
                                <label className="text-dark" >Descripción</label>
                            </div>
                            <div className="input-group py-2" style={{ height: "25px" }}>
                                <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>Reproducirlo ?</span>
                                <select className=" form-select form-select-sm text-center m-0 p-0"
                                    value={paraVerlo}
                                    style={{ height: "25px" }}
                                    onChange={(e) => setParaVerlo(e.target.value)}>
                                    <option value='L'>No</option>
                                    <option value='V'>Si</option>
                                </select>
                            </div>
                        </div>
                        <div className='card-footer text-end'>
                            <button className='btn btn-success btn-sm' onClick={agregarLink}>
                                <i className="fa-brands fa-youtube"></i> Agregar
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default NuevaNoticia
